module.exports = __webpack_public_path__ + "media/images/logo_w-955de9e84fe037a0829448bd0b369c4b.svg";